<!-- 系统管理-菜单管理 -->
<template>
  <div class="main-body">
    <div class="face-img">
      <image-select
        slot="icon"
        :file_type="['jpge','jpg','png']"
        :path="form.Form.user_icon" 
        @updatePath="value => form.Form.user_icon = value" 
        :selectBoxCss='{"width": "120px","height": "120px", "background": "#F3F3F3","display": "flex","align-items": "center","justify-content": "center","border":"none"}'
      >
        <img src="/icon/faceicon.svg" width="64" height="64"/>
        <!-- <p style="font-size: 10px;line-height: 12px;margin-top: 2px;margin-bottom: 0px;">{{$I18n("upload_photo")}}</p> -->
      </image-select>
    </div>
    
    <div style="font-weight: 600;font-size: 14px;">
      {{$I18n("click_enter_face")}}
    </div>
    <div class="form">
      <!-- 机构名称 -->
      <div>
        <label class="md-form-label" >
          <i class="req">*</i>
          {{$I18n("insti_name")}} 
        </label>
        <div class="md-form-item" :style="{flex: 1}">
          <md-field>
            <md-input :style="{'width':'100%'}" v-model="home_name" disabled :placeholder="$I18n('insti_name')"/>
          </md-field>
        </div>
      </div>
      <!-- 名称 -->
      <div>
        <label class="md-form-label" >
          <i class="req">*</i>
          {{$I18n("name")}} 
        </label>
        <div class="md-form-item" :style="{flex: 1}">
          <md-field>
            <md-input :style="{'width':'100%'}" v-model="form.Form.user_name" :placeholder="$I18n('pls_enter')"/>
          </md-field>
        </div>
      </div>
      <!-- 邮箱 -->
      <div>
        <label class="md-form-label" >
          {{$I18n("email")}} 
        </label>
        <div class="md-form-item" :style="{flex: 1}">
          <md-field>
            <md-input :style="{'width':'100%'}" v-model="form.Form.email" :placeholder="$I18n('pls_enter')"/>
          </md-field>
        </div>
      </div>
      <!-- 部门 -->
      <div>
        <label class="md-form-label" >
          <i class="req">*</i>
          {{$I18n("department")}} 
        </label>
        <div class="md-form-item" :style="{flex: 1}">
          <md-field>
            <md-select :style="{'width':'100%'}" v-model="form.Form.dept_id" :placeholder="$I18n('department')">
              <md-option v-for="item in deptData" :key="item.id" :value="item.id">
                {{item.name}}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>

    <div style="margin: 22px 22px 0;width: calc(100% - 44px);">
      <md-button class="diy-back-blue big" @click="addMem" style="width: 100%;">
        {{$I18n("add")}}
      </md-button>
    </div>
    
  </div>
</template>
<script>
import { FormClass,emailLegal } from "@/common/tools.js";
export default {
  data() {
    return {
      childValue:"",
      home_name: "",
      form: new FormClass({
        user_icon:"",
        dept_id: {
          init: "",
          check:"required",
        },
        user_name: {
          init: "",
          check:"smallstr",
        },
        email: {
          init: "",
          check: function(val){
            if(!val){
              return false
            } else {
              return !emailLegal(val)
            }
          },
        },
      }),
      deptData: [],
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: { },
  methods: {
    addMem(){
      if (this.form.Check()) {
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return;
      }
      this.$api.a_Member({
        ...this.form.Form,
        home_id : this.$router.history.current.query.hid,
        qrcode_key: this.$router.history.current.query.qrkey,
        role_id: 3,
        op: 2,
      })
        .then(this.$Then(() => {
          this.form.Reset();
          this.$successMsg(this.$I18n("add_success"));
        }))
        .catch(this.$Catch(this.$I18n("add_fail")))
    },
    api_getPageData(){ // API-获取主菜单信息
      // this.$api.g_Organi({}).then(res => console.log(res))
      return this.$api.g_OrganiDepart({
        home_id: this.$router.history.current.query.hid,
      })
        .then(this.$Then(res => {
          this.deptData = res.data.depts;
          this.home_name = res.data.home_name;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.deptData = [];
        }))
    },
  },
}
</script>
<style scoped>
.md-form-label{
  font-size: 14px;
  font-weight: 600;
}
.diy-back-blue.big.md-button{
  height: 45px !important;
}
.req{
  color: red;
  position: absolute;
  left:13px;
  font-weight: 400;
}
.form{
  padding: 22px;
  position: relative;
  width: 100%;
}
.main-body{
  display: flex;
  background: #FFFFFF;
  min-height: 100vh;
  width: 100%;
  flex-direction: column;
  align-items: center;
}
.face-img{
  margin: 20px 0 12px;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>